(function($) {
    $(function() {
        $('.sp_subject__slider').slick({
            mobileFirst: true,
            dots: true,
            infinite: true,
            speed: 1000,
            fade: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 8000,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: false,
                        arrows: true
                    }
                }
            ]
        });
    });
})(jQuery);